import './CountTag.scss';
import classNames from 'classnames';
import { isNumber } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { When } from 'react-if';

export interface CountTagProps {
	className?: string;
	color: string;
	count?: number;
	icon: React.ReactNode;
	tooltip?: string | React.ReactNode | (() => React.ReactNode);
	tooltipPlacement?: TooltipPlacement;
	visible?: boolean;
}

function getCountTagBase(
	className: string | undefined,
	color: string,
	count: number | undefined,
	icon: React.ReactNode,
	rest: Record<string, unknown>
) {
	const style = {
		borderColor: color,
		color
	};

	return (
		<div
			className={ classNames('count-tag', className) }
			style={ style }
			{ ...rest }>
			{ icon }
			<When condition={ isNumber(count) }>
				<span className='count'>{ count }</span>
			</When>
		</div>
	);
}

export const CountTag: React.FC<CountTagProps> = ({
	className,
	color,
	count,
	icon,
	tooltip,
	tooltipPlacement = 'bottomLeft',
	visible,
	...rest
}) => {
	if (visible === false) {
		return null;
	}

	const tagBase = getCountTagBase(className, color, count, icon, rest);

	if (!tooltip) {
		return tagBase;
	}

	return (
		<Tooltip
			placement={ tooltipPlacement }
			title={ tooltip }>
			{ tagBase }
		</Tooltip>
	);
};
